import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m 17,13 c 0,2.7614 -2.2386,5 -5,5 -2.76142,0 -5,-2.2386 -5,-5 0,-2.7614 2.23858,-5 5,-5 2.7614,0 5,2.2386 5,5 z m -5,-3 c -1.6569,0 -3,1.3431 -3,3 0,1.6569 1.3431,3 3,3 1.6569,0 3,-1.3431 3,-3 0,-1.6569 -1.3431,-3 -3,-3 z M 19.3787,3.51493 20,6 h 1 c 1.1046,0 2,0.89543 2,2 v 12 c 0,1.1046 -0.8954,2 -2,2 H 3 C 1.89543,22 1,21.1046 1,20 V 8 C 1,6.89543 1.89543,6 3,6 H 4 L 4.62127,3.51493 C 4.84385,2.62459 5.64382,2 6.56155,2 H 17.4384 c 0.9178,0 1.7177,0.62459 1.9403,1.51493 z M 3,8 V 20 H 21 V 8 H 20 C 19.0823,8 18.2823,7.37541 18.0597,6.48507 L 17.4384,4 H 6.56155 L 5.94029,6.48507 C 5.7177,7.37541 4.91774,8 4,8 Z"
  }));
});
var MultimediaCamera = AbstractIcon.withComponent(Icon);
MultimediaCamera.displayName = 'MultimediaCamera';
export default MultimediaCamera;